import { Injectable } from '@angular/core';
import { ApiError } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ServicoMensagemAplicacao {
  private timer?: number;
  private textoAtual = '';

  get texto() {
    return this.textoAtual;
  }

  mostrar(texto: string, duracaoMs = 10000) {
    this.textoAtual = texto;
    this.cancelarTimer();

    if (texto) {
      this.timer = window.setTimeout(() => {
        this.textoAtual = '';
        this.timer = undefined;
      }, duracaoMs);
    }
  }

  limpar() {
    this.textoAtual = '';
    this.cancelarTimer();
  }

  erroApi(error: ApiError, fallback: string) {
    const detail = typeof error.error?.detail === 'string' ? error.error.detail : '';
    const message = typeof error.error?.message === 'string' ? error.error.message : '';
    return detail || message || fallback;
  }

  registroSalvo(editando = false) {
    return editando
      ? 'Sucesso.\nRegistro alterado com sucesso.'
      : 'Sucesso.\nRegistro salvo com sucesso.';
  }

  registroExcluido() {
    return 'Sucesso.\nRegistro excluído com sucesso.';
  }

  erroRegistroPonto(error: ApiError) {
    const detail = typeof error.error?.detail === 'string' ? error.error.detail : '';
    if (detail.includes('Fora do horario permitido')) {
      return detail;
    }
    if (detail.includes('Limite de batidas') || detail.includes('Limite de 4 batidas')) {
      return 'Você ultrapassou o limite de batidas permitidas.';
    }
    if (detail.includes('Batida deste horario ja registrada')) {
      const complemento = detail
        .replace(/^.*Batida deste horario ja registrada\.?\s*/i, '')
        .trim();
      return complemento
        ? `Batida registrada para esse horário.\n${complemento}`
        : 'Batida registrada para esse horário.';
    }
    if (detail.includes('Servidor nao pertence a este departamento')) {
      return 'Servidor não pertence a este departamento.';
    }
    if (
      detail.includes('Face nao encontrada')
      || detail.includes('Reconhecimento facial ambiguo')
      || detail.includes('Nenhum funcionario com face cadastrada')
    ) {
      return 'Servidor nao identificado. Posicione o rosto novamente.';
    }
    if (detail.includes('Descritor facial') || detail.includes('Face nao confere') || detail.includes('Funcionario sem face')) {
      return detail;
    }
    return 'Servidor nao identificado. Posicione o rosto novamente.';
  }

  batidaJaRegistrada(nome: string, dataHora?: string) {
    const nomeServidor = (nome || '').trim();
    const instante = this.formatarInstantePonto(dataHora);
    const complemento = [nomeServidor, instante].filter(Boolean).join(' ');
    return complemento
      ? `Batida registrada para esse horário.\n${complemento}`
      : 'Batida registrada para esse horário.';
  }

  private formatarInstantePonto(dataHora?: string) {
    const data = dataHora ? new Date(dataHora) : new Date();
    if (Number.isNaN(data.getTime())) {
      return '';
    }
    const dia = data.toLocaleDateString('pt-BR');
    const hora = data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    return `${dia} ${hora}`;
  }

  private cancelarTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = undefined;
    }
  }
}
